// extracted by mini-css-extract-plugin
export default {"deleteButton":"EditDownloadClientModalContent-deleteButton-dwUEi Button-button-paJ9a Link-link-RInnp","message":"EditDownloadClientModalContent-message-XIiHZ Alert-alert-_KgnQ"};